module.exports = __webpack_public_path__ + "static/media/mic_off_show.7a41d524.svg";